/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { CuraiRedirectContentActionTaken } from "./CuraiRedirectContentActionTaken";
import type { CuraiRedirectContentUserProgression } from "./CuraiRedirectContentUserProgression";

export interface CuraiRedirectContent {
  action_taken?: CuraiRedirectContentActionTaken;
  archived?: boolean;
  user_progression?: CuraiRedirectContentUserProgression;
}
